// axiosInterceptor.js
import axios from "axios";
import { clearLocalStoragePreservingTheme } from "../utils/Utility";
import { ToastContainer, toast } from "react-toastify";

export const setupAxiosInterceptors = (navigate) => {
 <ToastContainer closeButton={true} position="top-right" />
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      if (status === 401) {
        clearLocalStoragePreservingTheme();
        setTimeout(() => {
          toast.error("Session expired. Please login again."); 
        }, 100); 
        navigate("/sign-in");
        return;
      }
      return Promise.reject(error);
    }
  );
};
